<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on: dialog }">
      <v-list-item v-on="dialog" @click.stop="dialog = true">
        <v-list-item-title>Actualizar</v-list-item-title>
      </v-list-item>
    </template>
    <!-- Modal -->
    <v-card>
      <!-- Título -->
      <v-card-title>
        <p class="headline font-weight-bold mb-0">
          Actualiza la sucursal
        </p>
      </v-card-title>
      <v-card-text class="mb-0 pb-0">
        <!-- Formulario -->
        <v-container fluid class="pa-0">
          <v-row no-gutters>
            <!-- Nombre -->
            <v-flex xs12>
              <TextField
                class="mb-5"
                v-model="branchName"
                placeholder="Nombre"
              />
            </v-flex>
            <!--  Dirección -->
            <v-flex xs12>
              <AddressField
                placeholder="Dirección de la sucursal"
                v-on:address="onAddressChange"
              />
            </v-flex>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="reset">Cancelar</v-btn>
        <v-btn color="primary" text @click="updateBranch">Actualizar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// Importar componentes
import TextField from "@/components/TextField";
import AddressField from "@/components/AddressField";

// importar servicios
import BranchesServices from "@/services/BranchesServices";

export default {
  components: {
    TextField,
    AddressField
  },
  props: {
    branchId: {
      type: String
    }
  },
  data() {
    return {
      branchName: "",
      dialog: false,
      updatedBranch: {}
    };
  },
  methods: {
    onAddressChange: function(addressData) {
      this.address = addressData;
    },
    updateBranch: async function() {
      // Verificar si cambió algo
      if (!this.didSomethingChange) {
        this.$emit("branch-error", "Por favor rellena algún campo");
        return;
      }

      // Crear objeto para guardar lo camibios
      const updatedBranch = {};

      if (this.branchName.trim()) {
        updatedBranch["name"] = this.branchName;
      }

      if (this.address) {
        updatedBranch["location"] = {
          latitude: this.address.latitude,
          longitude: this.address.longitude,
          address: `${this.address.route ? this.address.route : ""} ${
            this.address.street_number ? this.address.street_number : ""
          } ${this.address.locality ? this.address.locality : ""}`
        };
      }

      try {
        // Actualizar sucursal
        await BranchesServices.updateBranchById(this.branchId, updatedBranch);

        // Cerramos dialogo y vaciamos campos
        this.reset();

        // Emitir evento
        this.$emit("branch-updated");
      } catch (err) {
        // Emitir evento con el error
        this.$emit("branch-error", err.message);
      }
    },
    reset: function() {
      // Vaciamos los campos
      this.branchName = null;
      this.updatedBranch = {};
      // Cerramos el dialogo
      this.dialog = false;
    }
  },
  computed: {
    didSomethingChange: function() {
      return (!!this.branchName && !!this.branchName.trim()) || !!this.address;
    }
  }
};
</script>
